import ColumnMapping from '../../../../../components/units/Management/AiAgent/Template/ColumnMapping';

export default function TemplateRegisterPage() {
  return <ColumnMapping />;
}
